import React from "react";

import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";

import Radio from "@app/analytics/components/Radio";

import { RecommendedBadge } from "@rui/Badge";
import { Column, Row } from "@rui/Stack";

const SettingRadio = <T extends string>({
  value,
  checked,
  disabled = false,
  label,
  recommended = false,
  description,
}: {
  value: T;
  checked: boolean;
  disabled?: boolean;
  label: string;
  recommended?: boolean;
  description?: string;
}) => {
  return (
    <Column sx={description ? { my: 0.5 } : undefined}>
      <FormControlLabel
        control={<Radio value={value} />}
        checked={checked}
        disabled={disabled}
        label={
          <Row variant="left" spacing={1}>
            <Typography
              variant={description ? "bodySecondaryMed" : "bodySecondaryReg"}
              color="shades.neutral.600"
            >
              {label}
            </Typography>
            {recommended && <RecommendedBadge />}
          </Row>
        }
      />
      {description && (
        <Typography
          variant="bodySecondaryReg"
          color="shades.neutral.600"
          sx={{ marginLeft: 4, marginTop: "-5px" }}
        >
          {description}
        </Typography>
      )}
    </Column>
  );
};

export default SettingRadio;
